export const addCalendarYear = (date: Date) => {
    const dt = new Date(date);
    dt.setFullYear(dt.getFullYear() + 1);
    dt.setDate(dt.getDate() - 1);
    return dt;
};
